module.exports = __webpack_public_path__ + "static/cesar-e05f1857a6cb6f7daa72c95656618bb2.png";